import "../styles/main.scss";

// import Sticky from "sticky-js";
// import Rellax from "rellax";
import fslighbox from "fslightbox";
// import './vendor/jquery-1.6.1.min';
// import './vendor/jquery.prettyPhoto.js';

// console.log($(".js-slider-offer-gallery [data-fslightbox]"))
// $(".js-slider-offer-gallery [data-fslightbox]").prettyPhoto();

import ScrollAction from "./modules/scroll-action";

// import anime from "animejs";
// import "./vendor/paraxify.js";

import "./use-cases/loader";
import "./use-cases/slider";
import "./use-cases/interacts";
import "./use-cases/reveal";
// import "./use-cases/onscroll";
import "./use-cases/modal";
import "./use-cases/lazyload";
import "./use-cases/accordion";
import "./use-cases/cookies";
import "./use-cases/svg";
import "./use-cases/vue";
import "./use-cases/select";
import "./use-cases/cf7";
import "./use-cases/ddd";
import "./use-cases/animatedGIF";

require('./modules/lightboxWPGallery');

new ScrollAction({
	wrapper: ".js-site-header",
	offset: 0,
	classToAdd: "is-sticky",
	postClassToAdd: "is-post-sticky",
	preClassToAdd: "is-pre-sticky",
	prePostClassesTimeout: 1,
}).init();
